var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"publish-chips",style:(!_vm.isPublished
            ? 'background: #FFF2F2;max-width: 150px;'
            : 'max-width: 150px;')},[_c('div',{staticStyle:{"width":"16px","margin":"2px 8px 0 0"}},[(_vm.isPublished)?_c('EyeFillIcon'):_c('EyeIconSlashed')],1),_c('p',[_vm._v(" "+_vm._s(_vm.textString)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }